import { render } from "./AuthSelector.vue?vue&type=template&id=4ddfedee"
import script from "./AuthSelector.vue?vue&type=script&lang=js"
export * from "./AuthSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__